import React from 'react';
import get from 'lodash/get';
import eventBus from 'general/js/event-bus';
import app, { EVENT_DEVICE_TYPE_CHANGED, DEVICE_TYPE_MOBILE } from 'general/js/app';
import { playerSitecoreData } from 'components/live-player';
import LeaderboardFeaturedGroupLive from './leaderboard-featured-group-live';
import LeaderboardTeeTimesGroup from './leaderboard-tee-times-group';
import { playOffStatuses, viewTypes } from '../enums';


class LeaderboardCellPlayerExtra extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            deviceType: app.deviceTypeByViewport
        };
    }

    componentDidMount() {
        eventBus.addListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);
    }

    componentWillUnmount() {
        eventBus.removeListener(EVENT_DEVICE_TYPE_CHANGED, this.onDeviceTypeChanged);
    }

    onDeviceTypeChanged = (oldDeviceType, newDeviceType) => {
        this.setState({
            deviceType: newDeviceType
        });
    }

    renderPlayOffStatus() {
        const { player, hasChampion } = this.props;
        const playerSD = player.sitecoreData || playerSitecoreData;

        if (hasChampion) return null;

        if (playerSD.suddenDeathStatus &&
            playerSD.suddenDeathStatus !== playOffStatuses.NOT_PLAYING) {
            return 'Sudden death';
        }

        if (playerSD.playOffStatus &&
            playerSD.playOffStatus !== playOffStatuses.NOT_PLAYING) {
            return 'Play off';
        }

        return null;
    }

    render() {
        const { player, view, isPlayOff, currentRound, scoringLeaderboard } = this.props;
        const selectedRound = get(scoringLeaderboard, 'currentRound');
        const featuredGroupLiveUrl = get(player, 'sitecoreData.featuredGroupLiveUrl');

        return (
            <div className="leaderboard__cell-player-basic-col-2">
                <LeaderboardFeaturedGroupLive targetUrl={featuredGroupLiveUrl} />
                {
                    (currentRound == selectedRound) &&
                    <LeaderboardTeeTimesGroup {...this.props} />
                }
                {
                    isPlayOff &&
                    view === viewTypes.HOLE_BY_HOLE &&
                    <div className="leaderboard__playoff-status">{this.renderPlayOffStatus()}</div>
                }
            </div>
        );
    }
}

export default LeaderboardCellPlayerExtra;
